import { TextField } from "@mui/material"
import { GRID_FORM_CONFIG_T } from "../../../../../common/FormGenerator"

export type FiltrationBlockName =
    | "titleWhatAvailable"
    | "descriptionWhatAvailable"


export const titleWhatAvailableConfig = [
    [
        {
            id: 1,
            controllerName: "title", 
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Название...",
                fullWidth: true,
                size: "small",
                inputProps: { maxLength: 60 },
            }),
        }
    ],
];

export const descriptionWhatAvailableConfig = [
    [
        {
            id: 2,
            controllerName: "description",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Описание...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        }
    ],
];


const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
    titleWhatAvailable: titleWhatAvailableConfig,
    descriptionWhatAvailable: descriptionWhatAvailableConfig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]

export const getDynamicConfig = (blockName: FiltrationBlockName, index: number, arrayName: string): GRID_FORM_CONFIG_T<any> => {
    const config = getFormConfig(blockName);
    
    return [...config.map(row => 
        row.map(field => ({
            ...field,
            controllerName: `${arrayName}.${index}.${field.controllerName}`
        }))
    )];
};
